import moment from "moment"

var build_daily_access = function(data) {
    var ctx = document.getElementById('myChart').getContext('2d');
    var color = Chart.helpers.color;
    var cfg = {
        data: {
            datasets: [{
                    label: 'Accesos Nuevos',
                    backgroundColor: 'rgba(55,0,0,1)',
                    borderColor: 'rgba(55,0,0,1)',
                    data: data.daily_access_new,
                    type: 'line',
                    pointRadius: 0,
                    fill: false,
                    lineTension: 0,
                    borderWidth: 2
                },
                {
                    label: 'Accesos Repetidos',
                    backgroundColor: 'rgba(55,100,0,1)',
                    borderColor: 'rgba(55,100,0,1)',
                    data: data.daily_access_old,
                    type: 'line',
                    pointRadius: 0,
                    fill: false,
                    lineTension: 0,
                    borderWidth: 2
                }
            ]
        },
        options: {
            maintainAspectRatio: false,
            responsive: true,
            animation: {
                duration: 0
            },
            scales: {
                xAxes: [{
                    type: 'time',
                    distribution: 'series',
                    offset: true,
                    ticks: {
                        major: {
                            enabled: true,
                            fontStyle: 'bold'
                        },
                        source: 'data',
                        autoSkip: true,
                        autoSkipPadding: 75,
                        maxRotation: 0,
                        sampleSize: 100,
                        precision:0
                    },
                    afterBuildTicks: function(scale, ticks) {
                        var majorUnit = scale._majorUnit;
                        if(ticks == null ||ticks == undefined){
                        	return ticks;
                        }
                        var firstTick = ticks[0];
                        var i, ilen, val, tick, currMajor, lastMajor;

                        val = moment(ticks[0].value);
                        if ((majorUnit === 'minute' && val.second() === 0) ||
                            (majorUnit === 'hour' && val.minute() === 0) ||
                            (majorUnit === 'day' && val.hour() === 9) ||
                            (majorUnit === 'month' && val.date() <= 3 && val.isoWeekday() === 1) ||
                            (majorUnit === 'year' && val.month() === 0)) {
                            firstTick.major = true;
                        } else {
                            firstTick.major = false;
                        }
                        lastMajor = val.get(majorUnit);

                        for (i = 1, ilen = ticks.length; i < ilen; i++) {
                            tick = ticks[i];
                            val = moment(tick.value);
                            currMajor = val.get(majorUnit);
                            tick.major = currMajor !== lastMajor;
                            lastMajor = currMajor;
                        }
                        return ticks;
                    }
                }],
                yAxes: [{
                    gridLines: {
                        drawBorder: false
                    },
                    scaleLabel: {
                        display: true,
                        labelString: 'Accesos'
                    }
                }]
            },
            tooltips: {
                intersect: false,
                mode: 'index',
                callbacks: {
                    label: function(tooltipItem, myData) {
                        var label = myData.datasets[tooltipItem.datasetIndex].label || '';
                        if (label) {
                            label += ': ';
                        }
                        label += parseFloat(tooltipItem.value).toFixed(0);
                        return label;
                    }
                }
            }
        }
    };
    var chart = new Chart(ctx, cfg);
}

var build_new_access = function(data) {

}



var init_dashboard = function() {
    $.ajax({
        type: "GET",
        url: "/admin/dashboard.json",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function(data) {
            build_new_access(data);
            build_daily_access(data);
        },
        error: function(xhr, textStatus, errorThrown) {
            alert("ERROR");
            console.log(textStatus, errorThrown, xhr);
        }
    });
}

$(document).on('ready turbolinks:load', function() {
    var ele = document.getElementById('myChart');
    if (ele == null) {
        return;
    }
    init_dashboard();
});